// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"26c1fb93","232":"00491f1e","242":"18f967c9","337":"b88017ce","476":"1dbf73ba","706":"01c63f2a","738":"ad63cc97","804":"3a02be89","847":"efa48314","882":"eac7ff6d","939":"4ac7d854","965":"08b79db3","993":"ad004dff"}[chunkId] + ".chunk.js";
};